// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Kojx","col":"styles_col__BXk3u"};